import type { ParsedUrlQuery } from "querystring";
import type { UrlObject } from "url";
import { filterQueryParams } from "@/utils/url/filterQueryParams";

export function sanitizeHref(href: UrlObject): UrlObject {
  const query = isParsedUrlQuery(href.query)
    ? filterQueryParams(href.query)
    : href.query;

  return {
    ...href,
    query,
  };
}

function isParsedUrlQuery(query: UrlObject["query"]): query is ParsedUrlQuery {
  return typeof query === "object" && query !== null;
}
